import { AppState } from 'redux/reducers';

export const getPLTableLoading = ({ plTable }: AppState) => plTable.loading;
export const getIsPLTableFirstLoaded = ({ plTable }: AppState) => plTable.isFirstLoaded;
export const getPLTableAwayTeam = ({ plTable }: AppState) => plTable.awayTeam;
export const getPLTableHomeTeam = ({ plTable }: AppState) => plTable.homeTeam;
export const getPLTableCurrentPL = ({ plTable }: AppState) => plTable.currentPL;
export const getPLTableWorstCasePL = ({ plTable }: AppState) => plTable.worstCasePL;
